define([
	"dojo/_base/declare",
	"csi/heading/Controller",
	"csi/xml"
], function(declare,Controller,xml) {

	return declare(Controller, {
		toWriter: function() {
			// summary: bypass process function and go straight to publishing
			const { m_id } = this.heading;
			const cn = this.m_writer.changeNode(this.m_urlNode);

			cn.deleteAttribute(xml.idGetCommentColor(m_id));
			cn.deleteAttribute(xml.idGetComment(m_id));
		},

		postProcessSuccess: function() {
			// summary: refresh heading
			this.widget.refreshHeadingCell(this.getContext(), this.heading, this.refNode);
		}
	});
});